/**************************************************
 * Nombre:       Formulario_Comision_Ver_Consultor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {GavelOutlined, Inventory, Money, Person3Outlined, Person4Outlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";

const Formulario_Comision_Ver_Distribuidor = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1, mt: 2}}>
                    <Typography>Comisiones y valores</Typography>
                </Grid>


                <Grid container size={6}>
                    <IngresoDinero Icono={Money} nombre={'Valor producto en Bodega'}
                                   dato={'valorBodega'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Inventory} nombre={'Valor Ajuste Producto'}
                                   dato={'valorAjuste'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Person4Outlined} nombre={'Comision para Nieto'}
                                   dato={'valorComisionNieto'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Person3Outlined} nombre={'Comision para Hijo'}
                                   dato={'valorComisionHijo'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={GavelOutlined} nombre={'Valor Impuesto'}
                                   dato={'valorImpuesto'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Money} nombre={'Mi comision de venta'}
                                   dato={'valorComisionVenta'} {...props} editable={false}
                    />
                </Grid>



           
            </Grid>

        </form>

    )

}
export default Formulario_Comision_Ver_Distribuidor

